import { useAsyncData } from 'shared/hooks/useAsyncData';
import {
  ADMIN_ARENAS,
  ADMIN_DISPUTES,
  ADMIN_MODERATION,
  ADMIN_TRANSACTIONS,
  ARENAS_BY_PLAN,
  ARENAS_BY_STATUS,
  GMV_TREND,
  MRR_TREND,
  PLATFORM_KPIS,
  PLATFORM_REVENUE_SPLIT,
  WEBHOOK_EVENTS,
  WEBHOOK_KPIS,
  WEBHOOK_SUCCESS_TREND,
} from 'modules/admin/dashboard/content';
import { AdminDashboardData, fetchAdminDashboard } from 'modules/admin/dashboard/dashboardService';

const INITIAL_DATA: AdminDashboardData = {
  platformKpis: PLATFORM_KPIS,
  arenas: ADMIN_ARENAS,
  transactions: ADMIN_TRANSACTIONS,
  disputes: ADMIN_DISPUTES,
  moderationQueue: ADMIN_MODERATION,
  mrrTrend: MRR_TREND,
  gmvTrend: GMV_TREND,
  revenueSplit: PLATFORM_REVENUE_SPLIT,
  arenasByPlan: ARENAS_BY_PLAN,
  arenasByStatus: ARENAS_BY_STATUS,
  webhookKpis: WEBHOOK_KPIS,
  webhookSuccessTrend: WEBHOOK_SUCCESS_TREND,
  webhookEvents: WEBHOOK_EVENTS,
};

export function useAdminDashboard() {
  const { data, isLoading, error } = useAsyncData(fetchAdminDashboard, INITIAL_DATA);
  return { ...data, isLoading, error };
}
